import { ToolStatus } from '../types';
export class AssistantMessageFormatter {
    static formatMessageContent(message) {
        return message.content || '';
    }
    static formatToolStatus(tool, status, t) {
        const translate = (key, fallback) => t ? t(key, fallback) : fallback;
        switch (status) {
            case ToolStatus.PENDING:
                return translate('processing_input', 'Preparing...');
            case ToolStatus.RUNNING:
                return translate('tool_executing', 'Executing...');
            case ToolStatus.SUCCESS:
                return translate('complete', 'Completed successfully');
            case ToolStatus.FAILURE: {
                const errorMsg = tool.error || translate('error', 'Unknown error');
                return `${translate('error', 'Failed')}: ${errorMsg}`;
            }
            default:
                return translate('error', 'Unknown status');
        }
    }
    static formatToolArguments(tool) {
        try {
            return JSON.parse(tool.function.arguments);
        }
        catch (_a) {
            return tool.function.arguments;
        }
    }
    static formatToolResult(tool) {
        if (!tool.result)
            return null;
        return tool.result;
    }
    static formatExecutionTime(tool) {
        if (!tool.started_at || !tool.finished_at)
            return null;
        const start = new Date(tool.started_at).getTime();
        const end = new Date(tool.finished_at).getTime();
        const duration = end - start;
        if (!Number.isFinite(duration) || duration < 0)
            return null;
        if (duration < 1000) {
            return `${duration}ms`;
        }
        else {
            return `${(duration / 1000).toFixed(1)}s`;
        }
    }
    static extractGrantResults(tool) {
        if (tool.function.name !== 'search_grants' || !tool.result) {
            return [];
        }
        let grants;
        try {
            if (typeof tool.result.content === 'string') {
                grants = JSON.parse(tool.result.content);
            }
            else {
                grants = tool.result.content;
            }
        }
        catch (error) {
            console.error('Failed to parse grant results:', error);
            return [];
        }
        if (!Array.isArray(grants)) {
            return [];
        }
        return grants.map((grant) => {
            const status = grant.application_status || 'closed';
            let validStatus = 'closed';
            const validStatuses = [
                'open',
                'openingSoon',
                'closed',
                'closingSoon',
                'featured',
                'archived',
                'suspending',
            ];
            if (validStatuses.includes(status)) {
                validStatus = status;
            }
            return {
                grant_id: grant.grant_id,
                grant_display_title: grant.grant_display_title,
                grant_description_short: grant.grant_description_short,
                funding_max_amount: grant.funding_max_amount,
                funding_min_amount: grant.funding_min_amount,
                percentage_funding: grant.percentage_funding,
                grant_financing_type: grant.grant_financing_type,
                application_status: validStatus,
                grant_cities: grant.grant_cities,
                grant_provinces: grant.grant_provinces,
                country: grant.country,
                grant_logo: grant.grant_logo,
                grant_tags: grant.grant_tags,
                grant_is_subscribed: grant.grant_is_subscribed,
            };
        });
    }
    static hasToolCalls(message) {
        var _a;
        return Boolean(((_a = message.meta) === null || _a === void 0 ? void 0 : _a.tool_calls) && message.meta.tool_calls.length > 0);
    }
    static isToolMessage(message) {
        return message.role === 'tool';
    }
    static groupMessagesByAuthor(messages) {
        const groups = [];
        let currentGroup = [];
        let lastGroupKey = null;
        messages.forEach((message) => {
            const currentGroupKey = message.role === 'tool'
                ? 'tool'
                : `${message.role}-${message.author_id}`;
            if (lastGroupKey && lastGroupKey !== currentGroupKey) {
                if (currentGroup.length > 0) {
                    groups.push(currentGroup);
                }
                currentGroup = [message];
            }
            else {
                currentGroup.push(message);
            }
            lastGroupKey = currentGroupKey;
        });
        if (currentGroup.length > 0) {
            groups.push(currentGroup);
        }
        return groups;
    }
}
